import { CdkStepper } from '@angular/cdk/stepper';
import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatButtonModule, MatCheckboxChange, MatDialog, MatFormFieldModule, MatInputModule, MatStepper, MatStepperModule } from '@angular/material';
import { Search } from 'src/@core/interfaces/search';
import { AppService } from 'src/@core/services/app.service';
import { EmployerUploadService } from 'src/@core/services/employer/employer-upload.service';
import { JobService } from 'src/@core/services/job/job.service';
import { NotificationService } from 'src/@core/services/notification.service';
import { entityTypes, roles } from 'src/app/shared/helpers/roles-permissions';
import { CustomFieldsComponent } from './custom-fields/custom-fields.component';
import { Address } from 'src/@core/interfaces/address.model';
import { CreateEnterpriseUserComponent } from 'src/app/modules/enterprise-admin/users/enterprise-user/create-enterprise-user/create-enterprise-user.component';
import { API_ADD_AGENCY, API_APPROVE_AGENCY } from 'src/@core/services/util/api.endpoints';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { SuccessModalComponent } from '../success-modal/success-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { JobTypeService } from 'src/@core/services/job/job-type.service';
import { ProjetTypeService } from 'src/@core/services/project-type/projet-type.service';
@Component({
  selector: 'hour4u-admin-add-edit-project-new',
  templateUrl: './add-edit-project-new.component.html',
  styleUrls: ['./add-edit-project-new.component.scss'],
  providers: [
    MatStepper,
    CdkStepper,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule
  ]
})
export class AddEditProjectNewComponent implements OnInit {
  @ViewChild('stepper', { static: true }) stepper: MatStepper;
  projectFormGroup: FormGroup;
  locationFormGroup: FormGroup;
  trackingForm: FormGroup;
  billingFormGroup: FormGroup;
  termsFormGroup: FormGroup;
  isOptional = false;
  actionTitle: string = "Create";
  step = 0;

  roles = roles;
  entityTypes = entityTypes;
  enterprises: any[] = [];
  profile = this.appService.getCurrentAccount();
  isLoading: boolean = false;
  createEnterpriseLoading: boolean = false;
  selectedFieldIndex: any = null;
  diameter = 40;
  loaderColor: string;
  mode = 'indeterminate';
  selectedProjectDetails: any = null;
  fromWhere: string;

  jobTypes: any[];

  // STEP 1
  selectedClientType: string = "Existing";
  selectedProjectType: string = "Branding";
  brandingTypes: any[] = [];
  selectedFileNames: string[] = [];
  // activationTypes: any[] = [
  //   { value: 'manpower', display: 'Manpower' },
  //   { value: 'Society Activation', display: 'Society Activation' },
  //   { value: 'Hotspot', display: 'Hotspot' },
  //   { value: 'Corporate Activation', display: 'Corporate Activation' },
  //   { value: 'BRANDING', display: 'Branding' },
  // ];


  customFieldsArray: any[] = [];
  customFiles: any[] = [];
  customFilesName: any[] = [];

  // STEP 2
  selectedLocationType: string = "Single City";
  addressObj: Address = {};
  cities = [
    { value: 'Delhi', label: 'Delhi' },
    { value: 'Gurugram', label: 'Gurugram' },
    { value: 'Mumbai', label: 'Mumbai' },
    { value: 'Bangalore', label: 'Bangalore' },
    { value: 'Hyderabad', label: 'Hyderabad' },
    { value: 'Chennai', label: 'Chennai' },
    { value: 'Kolkata', label: 'Kolkata' },
    { value: 'Pune', label: 'Pune' },
    { value: 'Dehradun', label: 'Dehradun' },

  ];

  // STEP 3
  fieldsType: any[] = [
    {
      name: "",
      type: 'text',
      displyType: 'text',
      label: 'Text Field'
    },
    {
      name: "",
      type: 'tel',
      displyType: 'phone_number_tel',
      label: 'Phone Number'
    },
    {
      name: "phone_number_with_otp",
      type: 'tel',
      displyType: 'phone_number_with_otp',
      label: 'Phone Number with OTP'
    },
    {
      name: "",
      type: 'file',
      displyType: 'image_file',
      label: 'Image'
    },
    {
      name: 'order_id',
      type: 'text',
      displyType: 'order_id_text',
      label: 'Order Id'
    },
    {
      name: 'order_image',
      type: 'file',
      displyType: 'order_image_file',
      label: 'Order Image'
    }
  ];

  venueList: any = [] = [
    {
      name: 'Only GPS Co-ordinates',
      value: 'GPS_COORDINATES'
    },
    {
      name: 'Full Venue Details',
      value: 'FULL_VENUE_INFORMATION'
    }
  ];

  // STEP 4
  pageSizeOptions: number[] = [10, 20, 50, 100, 500];
  searchParams = [];
  resultsLength: number = 0;
  pageIndex: number = 0;
  pageSize: number = 100;
  teamMembers: any[] = [];
  searchByName: any = null;
  timeoutRef: ReturnType<typeof setTimeout>;
  selectedAll: boolean = false;
  selectedTeamMembers = [];
  showTemMembersAddSection: boolean = false;

  // STEP 5
  selectedBillingType: string = "FIXED";
  perList: any[] = [
    {
      name: 'Task',
      value: 'Task'
    },
    // {
    //   name: 'PER DURATION',
    //   value: 'PER DURATION'
    // },
    {
      name: 'Hour',
      value: 'Hour'
    },
    {
      name: 'Day',
      value: 'Day'
    },
    {
      name: 'Week',
      value: 'Week'
    },
    {
      name: 'Month',
      value: 'Month'
    },
  ];
  showBillingSection: boolean = true;
  filledProjectDetails: any = null;
  formDisplayPage: boolean = false;
  showTermsSection: boolean = true;
  hideUneditableFields: boolean = false;
  isUploading: boolean = false;

  dateFilter = (date: Date | null): boolean => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return date >= today;
  };


  constructor(
    private _formBuilder: FormBuilder,
    private appService: AppService,
    private jobService: JobService,
    private notify: NotificationService,
    private employerUploadService: EmployerUploadService,
    private dialog: MatDialog,
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    private jobTypeService: JobTypeService,
    private projectTypeService: ProjetTypeService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    console.log(this.profile);
    // STEP 1
    this.projectFormGroup = this._formBuilder.group({
      id: [''],
      employerId: ['', Validators.required],
      employerName: [''],
      selectedClientType: [this.selectedClientType],
      type: ['', Validators.required],

      jobTypeId: [''],
      projectCode: [''],
      title: ['', Validators.required],
      sop: [''],
      description: ['', Validators.required],
      attachments: this._formBuilder.array([]),
      fileAttachments: this._formBuilder.array([]),
      linksRequired: [true],
      links: this._formBuilder.array([this.linksForm()]),
      objectivesRequired: [true],
      objectives: this._formBuilder.array([this.objectivesForm()]),
      startDate: [null],
      endDate: [null],
      name: [],
      mobile: [],
      email: [],
      address: [],
    });

    if (this.profile.entity.entityType === 'AGENCY') {
      this.loadEnterprises();
    } else {
      this.showTermsSection = false;
      this.step = 1;
      this.projectFormGroup.controls['employerId'].setValue(this.profile.entity.id);
      this.projectFormGroup.controls['employerName'].setValue(this.profile.user.userMeta.name);
      this.projectFormGroup.controls['employerId'].updateValueAndValidity();
      this.projectFormGroup.controls['employerName'].updateValueAndValidity();
    }

    if (this.selectedProjectType == 'Branding') {
      this.setInitialBrandingList();
    }

    // STEP 2
    this.locationFormGroup = this._formBuilder.group({
      city: ['', Validators.required],
    });

    // STEP 3
    this.trackingForm = this._formBuilder.group({
      taskTrackingRequired: [true],
      deliverables: this._formBuilder.array([this.deliverablesForm()]),
      manpowerTrackingRequired: [true],
      attendanceLogInSelfieRequired: [false],
      attendanceLogOutSelfieRequired: [false],
      attendanceLocationTrackerRequired: [false],
      locationTrackingFrequency: [],
      geoFencingRadius: [],
      geoFencingRadiusRequired: [true],
      // venueTrackingRequired: [true],
      venueInformation: ['GPS_COORDINATES', [Validators.required]],
      quotationRequired: [false],
      // projectApprovalRequired: [true],
      workOrderApprovalRequired: [true],
      quotationApprovalRequired: [false],
      purchaseOrderRequired: [false],
      signatureRequired: [false]
    });

    if (this.profile.entity.entityType === 'AGENCY') {
      this.trackingForm.controls['quotationRequired'].setValue(true);
      this.trackingForm.controls['quotationRequired'].updateValueAndValidity();;
    }

    // STEP 4
    this.showTemMembersAddSection = false;
    // if (this.hasPermissions(['TEAM_MEMBERS_CREATE', 'TEAM_MEMBERS_EDIT'])) {
    //   this.showTemMembersAddSection = true;
    // }

    // STEP 5: Initialize billingFormGroup
    this.billingFormGroup = this._formBuilder.group({
      isBillingRequired: [true],
      billingType: [this.selectedBillingType],
      rateCards: this._formBuilder.array([this.createFixRateCard()]),
      variableJobRateCards: this._formBuilder.array([]),
    });

    // STEP 6
    this.termsFormGroup = this._formBuilder.group({
      expiryDate: [null, [Validators.required]],
      paymentTerms: ['', [Validators.required]],
      additionalTermsAndConditions: [''],
    })

    if (this.profile.entity.entityType === 'ENTERPRISE') {
      this.termsFormGroup.clearValidators();
      this.termsFormGroup.updateValueAndValidity();
    }

    // Automatically set the values for the first field in the deliverables form array
    const firstDeliverable = (this.trackingForm.get('deliverables') as FormArray).at(0);

    // Choose a default field type from fieldsType array
    const defaultFieldType = this.fieldsType[0]; // Change index to select a different field

    // Patch values from defaultFieldType
    firstDeliverable.patchValue({
      fieldType: defaultFieldType.type, // Set fieldType
      displayFieldType: defaultFieldType.displyType, // Set displayFieldType
      fieldLabel: defaultFieldType.label, // Set fieldLabel
      fieldName: defaultFieldType.name || defaultFieldType.label // Set fieldName to the name or label
    });

    // Generate the unique fieldName
    const fieldLabel = defaultFieldType.label;
    const lowerCaseName = fieldLabel.replace(/\s+/g, '_').toLowerCase();
    const fieldName = lowerCaseName + (defaultFieldType.type.includes('file') ? '_image_' : '_') + 0; // Index is 0 for the first field

    // Set the generated fieldName
    firstDeliverable.get('fieldName').setValue(fieldName);

    if (this.profile.roles.indexOf(roles.AGENCY_ADMIN) > -1 || this.profile.roles.indexOf(roles.AGENCY_STAFF) > -1) {
      this.trackingForm.controls['quotationRequired'].setValue(true);
      this.trackingForm.controls['quotationRequired'].updateValueAndValidity();
    }

    this.route.params.subscribe(data => {
      console.log(data)
      if (data.id) {
        this.projectFormGroup.controls['id'].setValue(data.id);
        if (data.action) {
          this.actionTitle = data.action;
        }
        this.getProjectDetailsById();
      }
    })

    this.loadJobTypes();
    this.fetchTeamMembers();
  }

  // Method to check if the user has both permissions
  hasPermissions(requiredPermissions: string[]): boolean {
    if (this.profile.permissions && this.profile.permissions.length)
      return requiredPermissions.some(permission => this.profile.permissions[0].includes(permission));
  }

  fetchTeamMembers() {
    this.searchParams = [];
    this.teamMembers = [];
    const entityId = this.profile.entity.id;
    this.isLoading = true;
    if (entityId) {
      this.searchParams = [];
      if (this.searchByName) {
        this.searchParams.push(new Search('query', this.searchByName));
      }

      // Add createdOn and desc to the payload
      const sortField = 'createdOn';
      const sortOrder = 'desc';
      this.jobService.searchAndSortTeamMembersv2(
        entityId,
        this.pageIndex,
        this.pageSize,
        sortField,
        sortOrder,
        this.searchParams
      ).subscribe(data => {
        this.teamMembers = data.content;
        this.isLoading = false;
        console.log(this.teamMembers)
        this.resultsLength = data.totalElements;
      }, error => {
        this.isLoading = false;
        this.notify.showMessage('Something went wrong!', 2000);
      });
    } else {
      console.warn('Entity ID is not available. Unable to fetch teamMembers.');
    }
  }

  // get Project Details By Id
  getProjectDetailsById() {
    this.isLoading = true;
    let params = {};
    if (this.profile && this.profile.entity && this.profile.entity.id) {
      if (this.profile.entity.entityType === 'AGENCY' || this.profile.entity.entityType === 'VENDOR') {
        params = { 'entityId': this.profile.entity.id };
      }
    }
    if (this.projectFormGroup.controls['id'].value) {
      this.jobService.getJobDetailsById(this.projectFormGroup.controls['id'].value, params).subscribe((job: any) => {
        this.isLoading = false;
        this.selectedProjectDetails = job;
        this.hideUneditableFields = false;
        this.showTermsSection = true;
        console.log("this.selectedProjectDetails---", this.selectedProjectDetails);

        if (this.profile.entity.entityType === 'AGENCY') {
          if (this.actionTitle == 'edit') {
            if (this.selectedProjectDetails && this.selectedProjectDetails.assignmentStatus && this.selectedProjectDetails.assignmentStatus == "ACCEPTED") {
              if (this.selectedProjectDetails.selectedClientType == 'Self') {
                if (true) {
                  //this.selectedProjectDetails.totalWorkOrders && this.selectedProjectDetails.totalWorkOrders > 0
                  this.hideUneditableFields = true;
                  this.showTermsSection = false;
                }
              } else if (true) {
                //this.selectedProjectDetails.totalWorkOrders && this.selectedProjectDetails.totalWorkOrders > 0
                this.hideUneditableFields = true;
                this.showTermsSection = false;
              }
            }
          }
        } else {
          this.showTermsSection = false;
        }
        this.mappingProjectValues();
      })
    } else {
      this.isLoading = false;
    }
  }

  // mapping Project Values
  mappingProjectValues() {
    // STEP 1
    // Clear the existing form arrays
    (this.projectFormGroup.get('attachments') as FormArray).clear();
    (this.projectFormGroup.get('fileAttachments') as FormArray).clear();
    (this.projectFormGroup.get('links') as FormArray).clear();
    (this.projectFormGroup.get('objectives') as FormArray).clear();
    // this.selectedFileNames = [];
    this.customFieldsArray = [];

    this.customFieldsArray = this.selectedProjectDetails.customFieldsArray;
    this.selectedClientType = this.selectedProjectDetails.selectedClientType;

    // Populate the form arrays with data
    if (this.selectedProjectDetails.attachments && this.selectedProjectDetails.attachments.length) {
      this.selectedProjectDetails.attachments.forEach(attachment => {
        (this.projectFormGroup.get('attachments') as FormArray).push(this.attachmentForm(attachment));
        // this.selectedFileNames.push(attachment);
      });
    }

    if (this.selectedProjectDetails.fileAttachments && this.selectedProjectDetails.fileAttachments.length) {
      this.selectedProjectDetails.fileAttachments.forEach(attachment => {
        (this.projectFormGroup.get('fileAttachments') as FormArray).push(this.attachmentsForm(attachment));
        // this.selectedFileNames.push(attachment);
      });
    }

    if (this.selectedProjectDetails.linksRequired) {
      if (this.selectedProjectDetails.links && this.selectedProjectDetails.links.length) {
        this.selectedProjectDetails.links.forEach(link => {
          (this.projectFormGroup.get('links') as FormArray).push(this.linksForm(link));
        });
      }
    }

    if (this.selectedProjectDetails.objectivesRequired) {
      if (this.selectedProjectDetails.objectives && this.selectedProjectDetails.objectives.length) {
        this.selectedProjectDetails.objectives.forEach(objective => {
          (this.projectFormGroup.get('objectives') as FormArray).push(this.objectivesForm(objective));
        });
      }
    }

    // Patch the rest of the form
    this.projectFormGroup.patchValue({
      id: this.selectedProjectDetails.id,
      employerId: this.selectedProjectDetails.employerId,
      employerName: this.selectedProjectDetails.employerName,
      selectedClientType: this.selectedProjectDetails.selectedClientType,
      type: this.selectedProjectDetails.type,
      projectCode: this.selectedProjectDetails.projectCode,
      title: this.selectedProjectDetails.title,
      sop: this.selectedProjectDetails.sop,
      description: this.selectedProjectDetails.description,
      startDate: this.convertArrayToDate(this.selectedProjectDetails.startDate),
      endDate: this.convertArrayToDate(this.selectedProjectDetails.endDate),
      name: this.selectedProjectDetails.name,
      mobile: this.selectedProjectDetails.mobile,
      email: this.selectedProjectDetails.email,
      address: this.selectedProjectDetails.address,
      linksRequired: this.selectedProjectDetails.linksRequired,
      objectivesRequired: this.selectedProjectDetails.objectivesRequired,
    });

    // STEP 2
    this.locationFormGroup.patchValue(this.selectedProjectDetails);
    this.addressObj = this.selectedProjectDetails.city;

    // STEP 3
    // Patching simple values
    this.trackingForm.patchValue({
      taskTrackingRequired: this.selectedProjectDetails.taskTrackingRequired,
      manpowerTrackingRequired: this.selectedProjectDetails.manpowerTrackingRequired,
      attendanceLogInSelfieRequired: this.selectedProjectDetails.attendanceLogInSelfieRequired,
      attendanceLogOutSelfieRequired: this.selectedProjectDetails.attendanceLogOutSelfieRequired,
      attendanceLocationTrackerRequired: this.selectedProjectDetails.attendanceLocationTrackerRequired,
      locationTrackingFrequency: this.selectedProjectDetails.locationTrackingFrequency,
      geoFencingRadius: this.selectedProjectDetails.geoFencingRadius,
      geoFencingRadiusRequired: this.selectedProjectDetails.geoFencingRadiusRequired,
      // venueTrackingRequired: this.selectedProjectDetails.venueTrackingRequired,
      venueInformation: this.selectedProjectDetails.venueInformation,
      quotationRequired: this.selectedProjectDetails.quotationRequired,
      workOrderApprovalRequired: this.selectedProjectDetails.workOrderApprovalRequired,
      quotationApprovalRequired: this.selectedProjectDetails.quotationApprovalRequired,
      purchaseOrderRequired: this.selectedProjectDetails.purchaseOrderRequired,
      signatureRequired: this.selectedProjectDetails.signatureRequired
    });

    // Patching deliverables form array
    const deliverablesArray = this.trackingForm.get('deliverables') as FormArray;
    deliverablesArray.clear();
    if (this.selectedProjectDetails.taskTrackingRequired) {
      if (this.selectedProjectDetails.deliverables && this.selectedProjectDetails.deliverables.length) {
        this.selectedProjectDetails.deliverables.forEach(deliverable => {
          deliverablesArray.push(this._formBuilder.group({
            fieldLabel: deliverable.fieldLabel,
            fieldType: deliverable.fieldType,
            fieldName: deliverable.fieldName,
            displayFieldType: deliverable.displayFieldType,
            mandatory: deliverable.mandatory
          }));
        });
      }
    }

    // STEP 4
    this.selectedTeamMembers = this.selectedProjectDetails.selectedTeamMembers || [];

    // STEP 5
    // Patching billingType
    this.billingFormGroup.patchValue({
      isBillingRequired: this.selectedProjectDetails.billingType == 'NONE' ? false : true,
      billingType: this.selectedProjectDetails.billingType
    });

    this.selectedBillingType = this.billingFormGroup.controls['billingType'].value;
    // Patching rateCards and variableJobRateCards based on billingType
    const rateCardsArray = this.billingFormGroup.get('rateCards') as FormArray;
    const variableJobRateCardsArray = this.billingFormGroup.get('variableJobRateCards') as FormArray;

    rateCardsArray.clear();
    variableJobRateCardsArray.clear();

    if (this.billingFormGroup.controls['isBillingRequired'].value) {
      if (this.selectedProjectDetails.billingType.includes('FIXED')) {
        // Populate rateCards
        if (this.selectedProjectDetails.rateCards && this.selectedProjectDetails.rateCards.length) {
          this.selectedProjectDetails.rateCards.forEach(rateCard => {
            rateCardsArray.push(this._formBuilder.group({
              type: [rateCard.type, Validators.required],
              quantity: [rateCard.quantity, [Validators.required, Validators.pattern(/^\d+$/)]],
              rate: [rateCard.rate, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
              totalAmount: [rateCard.totalAmount],
              saved: [false],
              expanded: [true],
              days: [rateCard.days, [Validators.required]],
              description: [rateCard.description]
            }));
          });
        }
      }

      if (this.selectedProjectDetails.billingType.includes('VARIABLE')) {
        // Populate variableJobRateCards
        if (this.selectedProjectDetails.variableJobRateCards && this.selectedProjectDetails.variableJobRateCards.length) {
          this.selectedProjectDetails.variableJobRateCards.forEach(variableCard => {
            variableJobRateCardsArray.push(this._formBuilder.group({
              type: [variableCard.type, Validators.required],
              quantity: [variableCard.quantity, Validators.required],
              rate: [variableCard.rate, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
              totalAmount: [variableCard.totalAmount],
              saved: [false],
              expanded: [true],
              description: [variableCard.description],
              per: [variableCard.per, Validators.required]
            }));
          });
        }
      }
    }

    if (this.selectedProjectDetails.selectedClientType == 'Self'
      || this.selectedProjectDetails.billingType == 'NONE') {
      this.showTermsSection = false;
      this.termsFormGroup.controls['paymentTerms'].setValidators([]);
      this.termsFormGroup.controls['paymentTerms'].updateValueAndValidity();
      this.termsFormGroup.controls['expiryDate'].setValidators([]);
      this.termsFormGroup.controls['expiryDate'].updateValueAndValidity();
      this.trackingForm.controls['quotationRequired'].setValue(false);
      this.trackingForm.controls['quotationRequired'].updateValueAndValidity();
      this.trackingForm.controls['quotationApprovalRequired'].setValue(false);
      this.trackingForm.controls['quotationApprovalRequired'].updateValueAndValidity();
    }

    console.log(this.billingFormGroup)

    // STEP 6
    // Patching termsFormGroup
    if (this.selectedProjectDetails.quoteConditions) {
      this.termsFormGroup.patchValue({
        expiryDate: this.convertArrayToDate(this.selectedProjectDetails.quoteConditions.expiryDate),
        paymentTerms: this.selectedProjectDetails.quoteConditions.paymentTerms,
        additionalTermsAndConditions: this.selectedProjectDetails.quoteConditions.additionalTermsAndConditions
      });
    }

    this.filledProjectDetails = this.selectedProjectDetails;
  }

  get attachments(): FormArray {
    return this.projectFormGroup.get('attachments') as FormArray;
  }

  get fileAttachments(): FormArray {
    return this.projectFormGroup.get('fileAttachments') as FormArray;
  }

  get rateCards(): FormArray {
    return this.billingFormGroup.get('rateCards') as FormArray;
  }

  get variableJobRateCards(): FormArray {
    return this.billingFormGroup.get('variableJobRateCards') as FormArray;
  }

  // convert Array To Date
  convertArrayToDate(dateArray: number[]): Date {
    if (!dateArray || dateArray.length < 3) return null;
    const [year, month, day] = dateArray;
    return new Date(year, month - 1, day);  // Note: JavaScript Date month is 0-indexed
  }

  // attachments Form init
  attachmentForm(attachment: any = ''): FormControl {
    return this._formBuilder.control(attachment);
  }

  // attachments Form init
  attachmentsForm(attachment: any = {}): FormGroup {
    return this._formBuilder.group({
      name: [attachment.name || ''],
      value: [attachment.value || ''],
    });
  }

  // links Form init
  linksForm(link: any = {}): FormGroup {
    return this._formBuilder.group({
      title: [link.title || ''],
      url: [link.url || ''],
    });
  }

  // objectives Form init
  objectivesForm(objective: any = {}): FormGroup {
    return this._formBuilder.group({
      metrics: [objective.metrics || ''],
      quantity: [objective.quantity || ''],
    });
  }

  // deliverables Form init
  deliverablesForm() {
    return this._formBuilder.group({
      fieldLabel: ['', [Validators.required]],
      fieldType: ['', [Validators.required]],
      fieldName: ['', [Validators.required]],
      displayFieldType: ['', [Validators.required]],
      mandatory: [false],
    });
  }

  get deliverablesControls() {
    return (this.trackingForm.get('deliverables') as FormArray).controls;
  }


  // create FixRateCards section Array
  createFixRateCardSectionArray(defaultType: string = ''): FormGroup {
    return this._formBuilder.group({
      sectionTitle: [''],
      isEditSectionTitle: [false],
      rateCards: this._formBuilder.array([this.createFixRateCard()]),
      variableJobRateCards: this._formBuilder.array([this.createVariableRateCard()]),
    })
  }

  // Utility method to create Fix Rate Cards FormGroup
  createFixRateCard(): FormGroup {
    return this._formBuilder.group({
      type: ['', Validators.required],
      quantity: ['', [Validators.required, Validators.pattern(/^\d+$/)]],
      rate: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      totalAmount: [''],
      saved: [false],
      expanded: [true],
      days: ['', [Validators.required]],
      description: ['']
    });
  }

  // Utility method to create Variable Rate Cards FormGroup
  createVariableRateCard(): FormGroup {
    return this._formBuilder.group({
      type: ['', Validators.required],
      quantity: ['', Validators.required],
      rate: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      totalAmount: [''],
      saved: [false],
      expanded: [true],
      description: [''],
      per: ['', Validators.required]
    });
  }

  // set the accordian's step
  setStep(index: number) {
    this.step = index;
  }

  // go to next step
  nextStep() {
    console.log(this.stepper.selectedIndex, this.step)
    if (this.stepper.selectedIndex == 0) {
      if (this.step == 0) {
        if (!this.projectFormGroup.value.employerId) {
          this.projectFormGroup.controls['employerId'].markAsTouched();
          this.projectFormGroup.controls['employerId'].updateValueAndValidity();
          return;
        } else {
          this.step = this.step + 1;
          return;
        }
      }
      if (this.step == 1) {
        if (!this.projectFormGroup.value.type) {
          this.projectFormGroup.controls['type'].markAsTouched();
          this.projectFormGroup.controls['type'].updateValueAndValidity();
          return;
        } else {
          this.step = this.step + 1;
          return;
        }
      }
    }
    // this.step = this.step + 1;
  }

  // go to prev step
  prevStep() {
    this.step = this.step - 1;
  }

  // go To Back Step
  goToBackStep() {
    if (this.stepper.selectedIndex > 0) {
      this.stepper.selectedIndex = this.stepper.selectedIndex - 1;
    }
  }

  // go To Next Step
  goToNextStep() {
    console.log(this.stepper.selectedIndex, this.projectFormGroup)
    if (this.stepper.selectedIndex == 0) {
      console.log(this.projectFormGroup)
      if (this.hideUneditableFields) {
        if (this.projectFormGroup.valid && this.locationFormGroup.valid &&
          this.billingFormGroup.valid && this.trackingForm.valid) {
          this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
          this.setupFormDetails();
          return;
        } else {
          this.projectFormGroup.markAllAsTouched();
          this.locationFormGroup.markAllAsTouched();
          this.billingFormGroup.markAllAsTouched();
          this.trackingForm.markAllAsTouched();
          return false;
        }
      } else {
        if (!this.projectFormGroup.valid) {
          this.projectFormGroup.markAllAsTouched();
          return false;
        } else {
          this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
          return false;
        }
      }
    }
    if (this.stepper.selectedIndex == 1) {
      if (this.hideUneditableFields) {
        if (this.projectFormGroup.valid && this.locationFormGroup.valid &&
          this.billingFormGroup.valid && this.trackingForm.valid) {
          // if (this.filledProjectDetails.signatureRequired) {
          //   this.openSignContract();
          //   return;
          // } else {
          this.saveProject();
          return;
          // }
        } else {
          this.projectFormGroup.markAllAsTouched();
          this.locationFormGroup.markAllAsTouched();
          this.billingFormGroup.markAllAsTouched();
          this.trackingForm.markAllAsTouched();
          return false;
        }
      } else {
        if (!this.locationFormGroup.valid) {
          this.locationFormGroup.markAllAsTouched();
          return false;
        } else {
          this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
          return false;
        }
      }
    }
    if (this.stepper.selectedIndex == 2) {
      if (this.hideUneditableFields) {
        if (!this.trackingForm.valid) {
          this.trackingForm.markAllAsTouched();
          return false;
        } else {
          this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
          return false;
        }
      } else {
        if (!this.trackingForm.valid) {
          this.trackingForm.markAllAsTouched();
          return false;
        } else {
          this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
          if (this.profile.entity.entityType === 'ENTERPRISE' || this.projectFormGroup.controls['selectedClientType'].value == 'Self' || this.billingFormGroup.controls['billingType'].value == 'NONE') {
            this.setupFormDetails();
          }
          return false;
        }
      }
    }

    if (this.getCTALabel() == "Add Billing") {
      if (!this.trackingForm.valid) {
        this.trackingForm.markAllAsTouched();
        return false;
      } else {
        this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
        return false;
      }
    }

    if (this.getCTALabel() == "Add Additional Terms") {
      if (this.showBillingSection) {
        if (!this.billingFormGroup.valid) {
          this.billingFormGroup.markAllAsTouched();
          return false;
        } else {
          this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
          return false;
        }
      } else {
        this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
        return false;
      }
    }

    if (this.getCTALabel() == "Review Project") {
      if (this.showBillingSection) {
        if (!this.billingFormGroup.valid) {
          const rateCardsArray = this.billingFormGroup.get('rateCards') as FormArray;
          const variableJobRateCardsArray = this.billingFormGroup.get('variableJobRateCards') as FormArray;
          if (!rateCardsArray.valid) {
            rateCardsArray.markAllAsTouched();
          }
          if (!variableJobRateCardsArray.valid) {
            variableJobRateCardsArray.markAllAsTouched();
          }
          this.billingFormGroup.markAllAsTouched();
          return false;
        }
      }

      if (this.showTermsSection) {
        if (!this.termsFormGroup.valid) {
          this.termsFormGroup.markAllAsTouched();
          return false;
        }
      }

      if (this.projectFormGroup.valid && this.locationFormGroup.valid &&
        this.billingFormGroup.valid && this.trackingForm.valid) {
        this.setupFormDetails();
        this.stepper.selectedIndex = this.stepper.selectedIndex + 1;
        return false;
      } else {
        this.projectFormGroup.markAllAsTouched();
        this.locationFormGroup.markAllAsTouched();
        this.billingFormGroup.markAllAsTouched();
        this.trackingForm.markAllAsTouched();
        return false;
      }
    }

    if (this.getCTALabel() == "Save Project") {
      const areFormsValid = this.projectFormGroup.valid &&
        this.locationFormGroup.valid &&
        this.trackingForm.valid &&
        (!this.showBillingSection || this.billingFormGroup.valid);
      if (!areFormsValid) {
        return false;
      }
      // If terms section is shown, validate it
      if (this.showTermsSection && !this.termsFormGroup.valid) {
        this.termsFormGroup.markAllAsTouched();
        return false;
      }
      // Handle signature or save the project
      if (this.filledProjectDetails.signatureRequired) {
        this.openSignContract();
      } else {
        this.saveProject();
      }
    }

    if (this.getCTALabel() == "Sign contract") {
      const areFormsValid = this.projectFormGroup.valid &&
        this.locationFormGroup.valid &&
        this.trackingForm.valid &&
        (!this.showBillingSection || this.billingFormGroup.valid);
      if (!areFormsValid) {
        return false;
      }

      // If terms section is shown, validate it
      if (this.showTermsSection && !this.termsFormGroup.valid) {
        this.termsFormGroup.markAllAsTouched();
        return false;
      }

      // Handle signature or save the project
      if (this.filledProjectDetails.signatureRequired) {
        this.openSignContract();
      } else {
        this.saveProject();
      }
    }
  }

  // setup save Form Details Object
  setupFormDetails() {
    if (this.profile.entity.entityType === 'AGENCY'
    ) {
    } else {
      this.projectFormGroup.controls['employerName'].setValue(this.profile.user.userMeta.name);
      this.projectFormGroup.controls['employerName'].updateValueAndValidity();
    }

    this.billingFormGroup.value.rateCards.forEach(element => {
      element.totalAmount = element.quantity * element.rate * element.days;
    });

    this.billingFormGroup.value.variableJobRateCards.forEach(element => {
      element.totalAmount = element.quantity * element.rate;
    });

    let startDate = null;
    if (this.projectFormGroup.controls['startDate'].value) {
      const startDateString = this.projectFormGroup.controls['startDate'].value;
      const startDateObj = new Date(startDateString);
      const startDateYear = startDateObj.getFullYear();
      const startDateMonth = startDateObj.getMonth() + 1;
      const startDateDay = startDateObj.getDate();
      startDate = [startDateYear, startDateMonth, startDateDay];
    }

    let endDate = null;
    if (this.projectFormGroup.controls['endDate'].value) {
      const endDateString = this.projectFormGroup.controls['endDate'].value;
      const endDateObj = new Date(endDateString);
      const endDateYear = endDateObj.getFullYear();
      const endDateMonth = endDateObj.getMonth() + 1;
      const endDateDay = endDateObj.getDate();
      endDate = [endDateYear, endDateMonth, endDateDay];
    }

    let expiryDate = null;
    if (this.termsFormGroup.controls['expiryDate'].value) {
      const dateString = this.termsFormGroup.controls['expiryDate'].value;
      const dateObj = new Date(dateString);
      const year = dateObj.getFullYear();
      const month = dateObj.getMonth() + 1;
      const day = dateObj.getDate();
      expiryDate = [year, month, day];
    }

    if (this.billingFormGroup.value.billingType == 'NONE' ||
      this.projectFormGroup.value.selectClientType == 'Self') {
      this.billingFormGroup.controls['isBillingRequired'].setValue(false);
      this.billingFormGroup.controls['isBillingRequired'].updateValueAndValidity();
      this.trackingForm.controls['quotationRequired'].setValue(false);
      this.trackingForm.controls['quotationRequired'].updateValueAndValidity();
      this.trackingForm.controls['quotationApprovalRequired'].setValue(false);
      this.trackingForm.controls['quotationApprovalRequired'].updateValueAndValidity();
    }

    if (this.actionTitle == 'clone') {
      this.projectFormGroup.controls['id'].setValue(null);
      this.projectFormGroup.controls['id'].updateValueAndValidity();
    }

    let selectedTeamMembers = [];
    if (this.selectedTeamMembers && this.selectedTeamMembers.length) {
      this.selectedTeamMembers.forEach(ele => {
        selectedTeamMembers.push({
          id: ele.user.id,
          name: ele.user.userMeta.name,
          email: ele.user.email,
          mobile: ele.user.mobile,
          role: ele.role.roleName
        });
      });
    }

    this.filledProjectDetails = {
      // STEP 1
      id: this.projectFormGroup.value.id,
      selectedClientType: this.projectFormGroup.value.selectedClientType,
      employerId: this.projectFormGroup.value.employerId,
      employerName: this.projectFormGroup.value.employerName,
      type: this.projectFormGroup.value.type,
      title: this.projectFormGroup.value.title,
      projectCode: this.projectFormGroup.value.projectCode,
      sop: this.projectFormGroup.value.sop,
      description: this.projectFormGroup.value.description,
      attachments: this.projectFormGroup.value.attachments,
      fileAttachments: this.projectFormGroup.value.fileAttachments,
      linksRequired: this.projectFormGroup.value.linksRequired,
      links: this.projectFormGroup.value.links,
      objectivesRequired: this.projectFormGroup.value.objectivesRequired,
      objectives: this.projectFormGroup.value.objectives,
      startDate: startDate,
      endDate: endDate,
      customFieldsArray: this.customFieldsArray,

      // STEP 2
      city: this.locationFormGroup.value.city,

      // STEP 3
      taskTrackingRequired: this.trackingForm.value.taskTrackingRequired,
      deliverables: this.trackingForm.value.deliverables,
      manpowerTrackingRequired: this.trackingForm.value.manpowerTrackingRequired,
      attendanceLogInSelfieRequired: this.trackingForm.value.attendanceLogInSelfieRequired,
      attendanceLogOutSelfieRequired: this.trackingForm.value.attendanceLogOutSelfieRequired,
      attendanceLocationTrackerRequired: this.trackingForm.value.attendanceLocationTrackerRequired,
      geoFencingRadius: this.trackingForm.value.geoFencingRadius,
      geoFencingRadiusRequired: this.trackingForm.value.geoFencingRadiusRequired,
      locationTrackingFrequency: this.trackingForm.value.locationTrackingFrequency,
      // venueTrackingRequired: this.trackingForm.value.venueTrackingRequired,
      venueInformation: this.trackingForm.value.venueInformation,
      quotationRequired: this.trackingForm.value.quotationRequired,
      // projectApprovalRequired: this.trackingForm.value.projectApprovalRequired,
      workOrderApprovalRequired: this.trackingForm.value.workOrderApprovalRequired,
      quotationApprovalRequired: this.trackingForm.value.quotationApprovalRequired,
      purchaseOrderRequired: this.trackingForm.value.purchaseOrderRequired,
      signatureRequired: this.trackingForm.value.signatureRequired,

      // STEP 4
      selectedTeamMembers: selectedTeamMembers,

      // STEP 5
      isBillingRequired: this.billingFormGroup.value.isBillingRequired,
      billingType: this.billingFormGroup.value.billingType,
      rateCards: this.billingFormGroup.value.rateCards,
      variableJobRateCards: this.billingFormGroup.value.variableJobRateCards,

      // STEP 6
      quoteConditions: {
        expiryDate: expiryDate,
        paymentTerms: this.termsFormGroup.value.paymentTerms,
        additionalTermsAndConditions: this.termsFormGroup.value.additionalTermsAndConditions
      }
    }
    console.log("this.filledProjectDetails---", this.filledProjectDetails);
  }

  // Save project details
  saveProject() {
    this.isLoading = true;
    if (this.filledProjectDetails.id) {
      // Update existing project
      // if (this.filledProjectDetails.billingType == "NONE" || this.filledProjectDetails.selectClientType == 'Self') {
      //   this.filledProjectDetails.quotationRequired = false;
      //   this.filledProjectDetails.quotationApprovalRequired = false;
      // } else {
      //   this.filledProjectDetails.quotationRequired = true;
      //   this.filledProjectDetails.quotationApprovalRequired = false;
      // }

      this.jobService.update(this.filledProjectDetails.id, this.filledProjectDetails).subscribe(
        (data) => {
          this.isLoading = false;
          this.notify.showMessage("Project updated successfully!", 2000);
          this.router.navigate(['/job'], { relativeTo: this.route });
          // if ((this.profile.entity.entityType === 'ENTERPRISE')) {
          this.openSuccessModal(data, 'Updated');
          // }
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.notify.showMessage("Error while updating project!", 2000);
        }
      );
    } else {
      // Create new project

      // if (this.filledProjectDetails.billingType == "NONE" || this.filledProjectDetails.selectClientType == 'Self') {
      //   this.filledProjectDetails.quotationRequired = false;
      //   this.filledProjectDetails.quotationApprovalRequired = false;
      // } else {
      //   this.filledProjectDetails.quotationRequired = true;
      //   this.filledProjectDetails.quotationApprovalRequired = false;
      // }

      this.jobService.create(this.filledProjectDetails).subscribe(
        (data) => {
          this.isLoading = false;
          this.notify.showMessage("Project created successfully!", 2000);
          this.router.navigate(['/job'], { relativeTo: this.route });
          // if ((this.profile.entity.entityType === 'ENTERPRISE')) {
          this.openSuccessModal(data, 'Created');
          // }
        },
        (error: HttpErrorResponse) => {
          this.isLoading = false;
          this.notify.showMessage("Error while creating project!", 2000);
        }
      );
    }
  }

  // Open success popup after adding project
  openSuccessModal(data?: any, action?: string) {
    data.action = action;
    const dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '600px',
      panelClass: 'assign-dialog',
      disableClose: true,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        // this.dataRefresh.emit();
      }
    });
  }

  openSignContract() {
    localStorage.setItem("selectedPojectData", JSON.stringify(this.filledProjectDetails));
    if (this.filledProjectDetails.id) {
      this.router.navigate(['/job/signed-doc/' + this.filledProjectDetails.id]);
    } else {
      this.router.navigate(['/job/signed-doc']);
    }
  }

  // disable CTA set
  disable() {
    let isDisabled = false;
    if (this.stepper.selectedIndex == 0) {
      if (!this.projectFormGroup.valid) {
        isDisabled = true;
      }
    }
    if (this.stepper.selectedIndex == 1) {
      if (!this.locationFormGroup.valid) {
        isDisabled = true;
      }
    }
    // if (this.stepper.selectedIndex == 2) {
    //   if (!this.TeammatesForm.valid) {
    //     isDisabled = true;
    //   }
    // }
    if (this.stepper.selectedIndex == 3) {
      if (!this.trackingForm.valid) {
        isDisabled = true;
      }
    }
    if (this.stepper.selectedIndex == 4) {
      if (!this.billingFormGroup.valid) {
        isDisabled = true;
      }
    }
    if (this.stepper.selectedIndex == 5) {
      if (this.profile.entity.entityType === 'ENTERPRISE' || this.projectFormGroup.controls['selectedClientType'].value == 'Self') {
        if (this.projectFormGroup.valid && this.locationFormGroup.valid &&
          this.billingFormGroup.valid && this.trackingForm.valid) {
          isDisabled = false;
        } else {
          isDisabled = true;
        }
      } else {
        if (!this.termsFormGroup.valid) {
          isDisabled = true;
        }
      }
    }

    if (this.isLoading) {
      isDisabled = true;
    }
    return isDisabled;
  }

  // get CTA Label
  getCTALabel() {
    let label = 'Next';

    if (this.stepper.selectedIndex == 0) {
      if (this.hideUneditableFields) {
        label = "Review Project";
      } else {
        label = "Select Location";
      }
    }

    if (this.stepper.selectedIndex == 1) {
      if (this.hideUneditableFields) {
        if (this.profile.entity.entityType === 'AGENCY' || this.projectFormGroup.controls['selectedClientType'].value != 'Self' || this.billingFormGroup.controls['billingType'].value != 'NONE') {
          label = "Save Project";
        }
        if (this.profile.entity.entityType === 'ENTERPRISE' || this.projectFormGroup.controls['selectedClientType'].value == 'Self' || this.billingFormGroup.controls['billingType'].value == 'NONE') {
          // if (this.trackingForm.value.signatureRequired) {
          //   label = "Sign contract";
          // } else {
          label = "Save Project";
          // }
        }
      } else {
        label = "Add Tracking";
      }
    }

    if (this.stepper.selectedIndex == 2) {
      if (this.showTemMembersAddSection) {
        label = "Add Teammates";
      } else {
        if (this.showBillingSection) {
          label = "Add Billing";
        } else {
          if (this.profile.entity.entityType === 'AGENCY' || this.projectFormGroup.controls['selectedClientType'].value != 'Self' || this.billingFormGroup.controls['billingType'].value != 'NONE') {
            label = "Add Additional Terms";
          }
          if (this.profile.entity.entityType === 'VENDOR' || this.profile.entity.entityType === 'ENTERPRISE' || this.projectFormGroup.controls['selectedClientType'].value == 'Self' || this.billingFormGroup.controls['billingType'].value == 'NONE') {
            label = "Review Project";
          }
        }
      }
    }

    if (this.stepper.selectedIndex == 3) {
      if (this.showBillingSection) {
        if (this.showTemMembersAddSection) {
          label = "Add Billing";
        } else {
          if (this.profile.entity.entityType === 'AGENCY' || this.projectFormGroup.controls['selectedClientType'].value != 'Self' || this.billingFormGroup.controls['billingType'].value != 'NONE') {
            label = "Add Additional Terms";
          }
          if (this.profile.entity.entityType === 'VENDOR' || this.profile.entity.entityType === 'ENTERPRISE' || this.projectFormGroup.controls['selectedClientType'].value == 'Self' || this.billingFormGroup.controls['billingType'].value == 'NONE') {
            label = "Review Project";
          }
        }
      } else {
        if (this.showTemMembersAddSection) {
          if (this.profile.entity.entityType === 'AGENCY' || this.projectFormGroup.controls['selectedClientType'].value != 'Self' || this.billingFormGroup.controls['billingType'].value != 'NONE') {
            label = "Add Additional Terms";
          }
          if (this.profile.entity.entityType === 'VENDOR' || this.profile.entity.entityType === 'ENTERPRISE' || this.projectFormGroup.controls['selectedClientType'].value == 'Self' || this.billingFormGroup.controls['billingType'].value == 'NONE') {
            label = "Review Project";
          }
        } else {
          if (this.profile.entity.entityType === 'AGENCY' || this.projectFormGroup.controls['selectedClientType'].value != 'Self' || this.billingFormGroup.controls['billingType'].value != 'NONE') {
            label = "Review Project";
          }
          if (this.profile.entity.entityType === 'VENDOR' || this.profile.entity.entityType === 'ENTERPRISE' || this.projectFormGroup.controls['selectedClientType'].value == 'Self' || this.billingFormGroup.controls['billingType'].value == 'NONE') {
            if (this.trackingForm.value.signatureRequired) {
              label = "Sign contract";
            } else {
              label = "Save Project";
            }
          }
        }
      }
    }

    if (this.stepper.selectedIndex == 4) {
      if (this.showBillingSection) {
        if (this.showTemMembersAddSection) {
          if (this.profile.entity.entityType === 'AGENCY' || this.projectFormGroup.controls['selectedClientType'].value != 'Self' || this.billingFormGroup.controls['billingType'].value != 'NONE') {
            label = "Add Additional Terms";
          }
          if (this.profile.entity.entityType === 'VENDOR' || this.profile.entity.entityType === 'ENTERPRISE' || this.projectFormGroup.controls['selectedClientType'].value == 'Self' || this.billingFormGroup.controls['billingType'].value == 'NONE') {
            label = "Review Project";
          }
        } else {
          if (this.profile.entity.entityType === 'AGENCY' || this.projectFormGroup.controls['selectedClientType'].value != 'Self' || this.billingFormGroup.controls['billingType'].value != 'NONE') {
            label = "Review Project";
          }
          if (this.profile.entity.entityType === 'VENDOR' || this.profile.entity.entityType === 'ENTERPRISE' || this.projectFormGroup.controls['selectedClientType'].value == 'Self' || this.billingFormGroup.controls['billingType'].value == 'NONE') {
            if (this.trackingForm.value.signatureRequired) {
              label = "Sign contract";
            } else {
              label = "Save Project";
            }
          }
        }
      } else {
        if (this.profile.entity.entityType === 'AGENCY' || this.projectFormGroup.controls['selectedClientType'].value != 'Self' || this.billingFormGroup.controls['billingType'].value != 'NONE') {
          // label = "Review Project";
          if (this.trackingForm.value.signatureRequired) {
            label = "Sign contract";
          } else {
            label = "Save Project";
          }
        }
        if (this.profile.entity.entityType === 'VENDOR' || this.profile.entity.entityType === 'ENTERPRISE' || this.projectFormGroup.controls['selectedClientType'].value == 'Self' || this.billingFormGroup.controls['billingType'].value == 'NONE') {
          if (this.trackingForm.value.signatureRequired) {
            label = "Sign contract";
          } else {
            label = "Save Project";
          }
        }
      }
    }

    if (this.stepper.selectedIndex == 5) {
      if (this.profile.entity.entityType === 'AGENCY' || this.projectFormGroup.controls['selectedClientType'].value != 'Self' || this.billingFormGroup.controls['billingType'].value != 'NONE') {
        // label = "Review Project";
        if (this.trackingForm.value.signatureRequired) {
          label = "Sign contract";
        } else {
          label = "Save Project";
        }
      }
      if (this.profile.entity.entityType === 'VENDOR' || this.profile.entity.entityType === 'ENTERPRISE' || this.projectFormGroup.controls['selectedClientType'].value == 'Self' || this.billingFormGroup.controls['billingType'].value == 'NONE') {
        if (this.trackingForm.value.signatureRequired) {
          label = "Sign contract";
        } else {
          label = "Save Project";
        }
      }
    }

    if (this.stepper.selectedIndex == 6) {
      if (this.trackingForm.value.signatureRequired) {
        label = "Sign contract";
      } else {
        label = "Save Project";
      }
    }
    return label;
  }

  // on Slide Toggle Change
  onSlideToggleChange(event, field) {
    console.log(event, field)
    if (field === 'taskTrackingRequired') {
      const deliverables = this.trackingForm.get('deliverables') as FormArray;
      if (deliverables.controls.length) {
        deliverables.controls.forEach(control => {
          if (event.checked) {
            control.get('fieldLabel').setValidators([Validators.required]);
            control.get('fieldType').setValidators([Validators.required]);
            control.get('fieldName').setValidators([Validators.required]);
            control.get('displayFieldType').setValidators([Validators.required]);
          } else {
            control.get('fieldLabel').clearValidators();
            control.get('fieldType').clearValidators();
            control.get('fieldName').clearValidators();
            control.get('displayFieldType').clearValidators();
          }
          control.get('fieldLabel').updateValueAndValidity();
          control.get('fieldType').updateValueAndValidity();
          control.get('fieldName').updateValueAndValidity();
          control.get('displayFieldType').updateValueAndValidity();
        });
      }
    }

    if (field === 'manpowerTrackingRequired') {
      if (event.checked) {
        this.trackingForm.controls['attendanceLogInSelfieRequired'].setValue(true);
        this.trackingForm.controls['attendanceLogOutSelfieRequired'].setValue(true);
        this.trackingForm.controls['attendanceLocationTrackerRequired'].setValue(true);
        this.trackingForm.controls['locationTrackingFrequency'].setValue("");
        this.trackingForm.controls['geoFencingRadius'].setValue("");
        this.trackingForm.controls['geoFencingRadiusRequired'].setValue(true);
        this.trackingForm.controls['locationTrackingFrequency'].setValidators([Validators.required])
        this.trackingForm.controls['geoFencingRadius'].setValidators([Validators.required])
      } else {
        this.trackingForm.controls['attendanceLogInSelfieRequired'].setValue(false);
        this.trackingForm.controls['attendanceLogOutSelfieRequired'].setValue(false);
        this.trackingForm.controls['attendanceLocationTrackerRequired'].setValue(false);
        this.trackingForm.controls['locationTrackingFrequency'].setValue("");
        this.trackingForm.controls['geoFencingRadius'].setValue("");
        this.trackingForm.controls['geoFencingRadiusRequired'].setValue(false);
        this.trackingForm.controls['locationTrackingFrequency'].setValidators([])
        this.trackingForm.controls['geoFencingRadius'].setValidators([])
      }

      this.trackingForm.controls['attendanceLogInSelfieRequired'].updateValueAndValidity();
      this.trackingForm.controls['attendanceLogOutSelfieRequired'].updateValueAndValidity();
      this.trackingForm.controls['attendanceLocationTrackerRequired'].updateValueAndValidity();
      this.trackingForm.controls['locationTrackingFrequency'].updateValueAndValidity();
      this.trackingForm.controls['geoFencingRadius'].updateValueAndValidity();
      this.trackingForm.controls['geoFencingRadiusRequired'].updateValueAndValidity();
    }

    if (field === 'geoFencingRadiusRequired') {
      if (event.checked) {
        this.trackingForm.controls['geoFencingRadius'].setValidators([Validators.required]);
      } else {
        this.trackingForm.controls['geoFencingRadius'].setValue("");
        this.trackingForm.controls['geoFencingRadius'].clearValidators();
      }
      this.trackingForm.controls['geoFencingRadius'].updateValueAndValidity();
    }

    if (field === 'quotationRequired') {
      if (event.checked) {
        //     this.trackingForm.controls['quotationApprovalRequired'].setValue(true);
      } else {
        this.trackingForm.controls['purchaseOrderRequired'].setValue(false);
        //     this.trackingForm.controls['quotationApprovalRequired'].setValue(false);
      }
      this.trackingForm.controls['purchaseOrderRequired'].updateValueAndValidity();
      //   this.trackingForm.controls['quotationApprovalRequired'].updateValueAndValidity();
    }

    if (field === 'quotationApprovalRequired') {
      if (event.checked) {
        this.trackingForm.controls['quotationRequired'].setValue(true);
      } else {
        this.trackingForm.controls['quotationRequired'].setValue(false);
        this.trackingForm.controls['purchaseOrderRequired'].setValue(false);
      }
      this.trackingForm.controls['purchaseOrderRequired'].updateValueAndValidity();
      this.trackingForm.controls['quotationRequired'].updateValueAndValidity();
    }

    // if (field === 'venueTrackingRequired') {
    // }
    if (field === 'isBillingRequired') {
      const rateCardsArray = this.billingFormGroup.get('rateCards') as FormArray;
      const variableRateCardsArray = this.billingFormGroup.get('variableJobRateCards') as FormArray;
      if (!event.checked) {
        this.showTermsSection = false;
        this.billingFormGroup.controls['billingType'].setValue('NONE');
        this.billingFormGroup.controls['billingType'].updateValueAndValidity();
        this.termsFormGroup.controls['paymentTerms'].setValidators([]);
        this.termsFormGroup.controls['paymentTerms'].updateValueAndValidity();
        this.termsFormGroup.controls['expiryDate'].setValidators([]);
        this.termsFormGroup.controls['expiryDate'].updateValueAndValidity();
        this.trackingForm.controls['quotationRequired'].setValue(false);
        this.trackingForm.controls['quotationRequired'].updateValueAndValidity();
        this.trackingForm.controls['quotationApprovalRequired'].setValue(false);
        this.trackingForm.controls['quotationApprovalRequired'].updateValueAndValidity();
        if (this.billingFormGroup.controls['billingType'].value.includes('NONE')) {
          variableRateCardsArray.clear();
          rateCardsArray.clear();
          // rateCardsArray.clearValidators();

          // rateCardsArray.controls.forEach(control => {
          //   control.clearValidators();
          //   control.updateValueAndValidity();
          // });

          // rateCardsArray.updateValueAndValidity();

          // variableRateCardsArray.clearValidators();

          // variableRateCardsArray.controls.forEach(control => {
          //   control.clearValidators();
          //   control.updateValueAndValidity();
          // });

          // variableRateCardsArray.updateValueAndValidity();
        }
        return;
      } else {
        if (this.profile.entity.entityType == 'AGENCY') {
          this.showTermsSection = true;
        }
        this.termsFormGroup.clearValidators();
        this.termsFormGroup.updateValueAndValidity();
        this.trackingForm.controls['quotationRequired'].setValue(true);
        this.trackingForm.controls['quotationRequired'].updateValueAndValidity();
        this.billingFormGroup.controls['billingType'].setValue('FIXED');
        this.billingFormGroup.controls['billingType'].updateValueAndValidity();
        this.termsFormGroup.controls['paymentTerms'].setValidators([Validators.required]);
        this.termsFormGroup.controls['paymentTerms'].updateValueAndValidity();
        this.termsFormGroup.controls['expiryDate'].setValidators([Validators.required]);
        this.termsFormGroup.controls['expiryDate'].updateValueAndValidity();
        if (this.billingFormGroup.controls['billingType'].value == 'FIXED') {
          variableRateCardsArray.clear();
          rateCardsArray.push(this.createFixRateCard());
          // variableRateCardsArray.clearValidators();

          // variableRateCardsArray.controls.forEach(control => {
          //   control.clearValidators();
          //   control.updateValueAndValidity();
          // });

          // variableRateCardsArray.updateValueAndValidity();
        }

        if (this.billingFormGroup.controls['billingType'].value == 'VARIABLE') {
          rateCardsArray.clear();
          variableRateCardsArray.push(this.createVariableRateCard());
          // rateCardsArray.clearValidators();

          // rateCardsArray.controls.forEach(control => {
          //   control.clearValidators();
          //   control.updateValueAndValidity();
          // });

          // rateCardsArray.updateValueAndValidity();
        }
      }
    }

    if (field === 'linksRequired') {
      const links = this.projectFormGroup.get('links') as FormArray;
      if (event.checked) {
        links.push(this.linksForm());
      } else {
        links.clear();
      }
    }

    if (field === 'objectivesRequired') {
      const objectives = this.projectFormGroup.get('objectives') as FormArray;
      if (event.checked) {
        objectives.push(this.objectivesForm());
      } else {
        objectives.clear();
      }
    }
  }

  // Load all enterprises
  loadEnterprises(id?: any) {
    let searchParams = [];
    this.enterprises = [];
    const entityId = this.profile.entity.id;
    // this.isLoading = true;

    if (entityId) {
      searchParams.push(new Search('fetchParent', true));

      searchParams.push(new Search('entityType', 'ENTERPRISE'));
      this.jobService.searchAndSortAgencies(
        entityId,
        0,
        1000,
        'createdOn',
        'desc',
        searchParams
      ).subscribe(
        (data) => {
          this.enterprises = data.content;
          // this.isLoading = false;
          console.log(this.enterprises);
          if (id) {
            const filteredEnterprises = this.enterprises.filter(enterprise => enterprise.id === id);
            console.log("++++++++++++++++", id, filteredEnterprises)
            if (filteredEnterprises && filteredEnterprises.length) {
              this.projectFormGroup.controls['employerName'].setValue(filteredEnterprises[0].entityMeta.name);
            }
            this.selectedClientType = 'Existing';
            this.projectFormGroup.controls['selectedClientType'].setValue(this.selectedClientType);
            this.projectFormGroup.controls['employerId'].setValue(id);
            this.projectFormGroup.controls['selectedClientType'].updateValueAndValidity();
            this.projectFormGroup.controls['employerId'].updateValueAndValidity();
            this.projectFormGroup.controls['employerName'].updateValueAndValidity();
          }

          // this.resultsLength = data.totalElements;
        },
        (error) => {
          // this.isLoading = false;
          this.notify.showMessage('Something went wrong!', 2000);
        }
      );

    } else {
      console.warn('Entity ID is not available. Unable to fetch enterprises.');
    }
  }

  // STEP 1

  // 1.1
  // whoich type of client select
  selectClientType(clientType) {
    this.selectedClientType = clientType;
    this.showTermsSection = true;
    this.projectFormGroup.controls['selectedClientType'].setValue(this.selectedClientType);
    if (this.selectedClientType == 'New') {
      this.projectFormGroup.controls['name'].setValidators([Validators.required]);
      this.projectFormGroup.controls['mobile'].setValidators([Validators.required, Validators.pattern('^[6-9][0-9]{9}$'), Validators.minLength(10), Validators.maxLength(10)]);
      this.projectFormGroup.controls['email'].setValidators([Validators.required, Validators.email]);
    } else {
      this.projectFormGroup.controls['name'].setValidators([]);
      this.projectFormGroup.controls['mobile'].setValidators([]);
      this.projectFormGroup.controls['email'].setValidators([]);
    }
    this.projectFormGroup.controls['name'].updateValueAndValidity();
    this.projectFormGroup.controls['mobile'].updateValueAndValidity();
    this.projectFormGroup.controls['email'].updateValueAndValidity();
    this.projectFormGroup.controls['selectedClientType'].updateValueAndValidity();

    if (this.selectedClientType == 'Self') {
      this.showTermsSection = false;
      this.projectFormGroup.controls['employerId'].setValue(this.profile.entity.id);
      this.projectFormGroup.controls['employerName'].setValue(this.profile.user.userMeta.name);
      this.projectFormGroup.controls['employerId'].updateValueAndValidity();
      this.projectFormGroup.controls['employerName'].updateValueAndValidity();

      this.trackingForm.controls['quotationRequired'].setValue(false);
      this.trackingForm.controls['workOrderApprovalRequired'].setValue(false);
      this.trackingForm.controls['quotationApprovalRequired'].setValue(false);
      this.trackingForm.controls['purchaseOrderRequired'].setValue(false);
      this.trackingForm.controls['signatureRequired'].setValue(false);

      this.trackingForm.controls['quotationRequired'].updateValueAndValidity();
      this.trackingForm.controls['workOrderApprovalRequired'].updateValueAndValidity();
      this.trackingForm.controls['quotationApprovalRequired'].updateValueAndValidity();
      this.trackingForm.controls['purchaseOrderRequired'].updateValueAndValidity();
      this.trackingForm.controls['signatureRequired'].updateValueAndValidity();
    } else {
      this.trackingForm.controls['quotationRequired'].setValue(true);
      this.trackingForm.controls['quotationRequired'].updateValueAndValidity();
    }
  }

  // selected enterprise
  selectedEnterprise(enterprise) {
    console.log(enterprise)
    this.projectFormGroup.controls['employerName'].setValue(enterprise.entityMeta.name);
    this.projectFormGroup.controls['employerName'].updateValueAndValidity();
  }

  createEnterprise() {
    this.createEnterpriseLoading = true;
    if (this.projectFormGroup.controls['name'].valid && this.projectFormGroup.controls['mobile'].valid
      && this.projectFormGroup.controls['email'].valid
    ) {
      const enterpriseData = {
        name: this.projectFormGroup.controls['name'].value,
        mobile: this.projectFormGroup.controls['mobile'].value,
        email: this.projectFormGroup.controls['email'].value,
        address: this.projectFormGroup.controls['address'].value,
        entityType: 'ENTERPRISE'
      };

      let url = null;
      if (this.profile.entity.entityType === 'AGENCY') {
        url = API_ADD_AGENCY + this.profile.entity.id + '?addParent=' + true;
      } else {
        url = API_ADD_AGENCY + this.profile.entity.id;
      }
      this.http.post(url, enterpriseData).toPromise()
        .then((response: any) => {
          this.createEnterpriseLoading = false;
          this.notify.showMessage('Enterprise user created successfully!', 2000);
          // Extract the ID from the response
          const entityId = response.id;
          this.loadEnterprises(response.parentEntity.id);
          this.projectFormGroup.controls['name'].setValue('');
          this.projectFormGroup.controls['name'].markAsUntouched();
          this.projectFormGroup.controls['mobile'].setValue('');
          this.projectFormGroup.controls['mobile'].markAsUntouched();
          this.projectFormGroup.controls['email'].setValue('');
          this.projectFormGroup.controls['email'].markAsUntouched();
          this.projectFormGroup.controls['address'].setValue('');
          this.projectFormGroup.controls['address'].markAsUntouched();
          this.projectFormGroup.controls['name'].setValidators([]);
          this.projectFormGroup.controls['mobile'].setValidators([]);
          this.projectFormGroup.controls['email'].setValidators([]);
          this.projectFormGroup.controls['address'].setValidators([]);
          this.projectFormGroup.controls['name'].updateValueAndValidity();
          this.projectFormGroup.controls['mobile'].updateValueAndValidity();
          this.projectFormGroup.controls['email'].updateValueAndValidity();
          this.projectFormGroup.controls['address'].updateValueAndValidity();

          // Make another API call with the extracted ID
          this.http.get(`${API_APPROVE_AGENCY}${entityId}/ACCEPTED`).toPromise()
            .then((secondApiResponse: any) => {
              console.log('Second API Response:', secondApiResponse);
            })
            .catch(error => {
              console.error('Error in second API call:', error);
              // Handle error response from the second API call
            });

        }).catch(error => {
          this.createEnterpriseLoading = false;
          console.error('Error creating enterprise entity:', error);
          // Handle error response from the first API call
        });
    } else {
      this.createEnterpriseLoading = false;
      this.projectFormGroup.controls['name'].markAsTouched();
      this.projectFormGroup.controls['mobile'].markAsTouched();
      this.projectFormGroup.controls['email'].markAsTouched();
    }
  }

  // 1.2
  // selected project Type
  selectProjectType(projectType) {
    this.selectedProjectType = projectType;
    if (this.selectedProjectType == 'Branding') {
      this.setInitialBrandingList();
    }
  }

  // Set branding list
  setInitialBrandingList() {
    this.brandingTypes = [
      { value: 'Manpower Required', display: 'Manpower Required' },
      { value: 'Corporate', display: 'Corporate' },
      { value: 'Product/Service', display: 'Product/Service' },
      { value: 'Event', display: 'Event' },
    ];
  }

  // selected branding type
  selectedBrandingType(branding) {
    console.log(branding)
  }

  // 1.3
  // write With AI tool
  writeWithAI() {

  }

  // on file select for attachments upload
  onFileSelected(event: Event, field?: any) {
    console.log(field)
    if (field) {
      field.isLoading = true;
      // field.value = [];
      // field.fileName = [];
    } else {
      this.isUploading = true;
    }
    const inputElement = event.target as HTMLInputElement;

    if (inputElement.files && inputElement.files.length > 0) {
      const attachmentsArray = this.projectFormGroup.get('fileAttachments') as FormArray;
      const attachments = this.projectFormGroup.get('attachments') as FormArray;

      for (let i = 0; i < inputElement.files.length; i++) {
        const file = inputElement.files[i];

        // Upload the file to S3 using the existing function
        this.employerUploadService.uploadProfileImage(file).subscribe(
          (s3File) => {
            console.log('File uploaded successfully:', s3File);
            if (field) {
              field.value.push(s3File.key);
              field.fileName.push(file.name);
            } else {
              let obj = {
                name: file.name,
                value: s3File.key
              }
              attachmentsArray.push(this.attachmentsForm(obj));
              attachments.push(this.attachmentForm(s3File.key));
              // this.selectedFileNames.push(file.name);
            }
            if (inputElement.files.length - 1 == i) {
              if (field) {
                field.isLoading = false;
              } else {
                this.isUploading = false;
              }
              console.log(this.customFieldsArray)
              console.log(attachmentsArray)
            }
          },
          (error) => {
            if (field) {
              field.isLoading = false;
            } else {
              this.isUploading = false;
            }
            console.error('Error uploading file:', error);
          }
        );
      }
    }
  }

  // delete Selected File
  deleteSelectedFile(index, fields?: any) {
    console.log(index, fields)
    if (fields) {
      fields.splice(index, 1);
    } else {
      const attachmentsArray = this.projectFormGroup.get('fileAttachments') as FormArray;
      attachmentsArray.removeAt(index);
      const attachments = this.projectFormGroup.get('attachments') as FormArray;
      attachments.removeAt(index);
      // this.selectedFileNames.splice(index, 1);
    }
  }

  // add more for links
  addMoreLinks() {
    const links = this.projectFormGroup.get('links') as FormArray;
    links.push(this.linksForm());
  }

  // delete Link
  deleteLink(index) {
    const links = this.projectFormGroup.get('links') as FormArray;
    links.removeAt(index);
  }

  // add more for objectives
  addMoreObjectives() {
    const objectives = this.projectFormGroup.get('objectives') as FormArray;
    objectives.push(this.objectivesForm());
  }

  // delete deliverable
  deleteObjective(index) {
    const objectives = this.projectFormGroup.get('objectives') as FormArray;
    objectives.removeAt(index);
  }

  // job Start Date Change
  jobStartDateChange(event) {

  }

  // job end Date Change
  jobEndDateChange(event) {

  }

  // delete Custom Field
  deleteCustomField(index, field) {
    this.customFieldsArray.splice(index, 1);
  }

  // job quote Date Change
  jobQuoteDateChange(event) {

  }

  // job custom Date Change
  jobCustomDateChange(event) {

  }

  // add Custom Fields
  addCustomFields() {
    const dialogRef = this.dialog.open(CustomFieldsComponent, {
      width: '600px',
      panelClass: 'assign-dialog',
      disableClose: true,
      // data: formData
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log(result)
      if (result) {
        this.customFieldsArray.push(result);
        this.customFieldsArray.forEach((ele, index) => {
          if (!ele.fieldName.includes('_' + index)) {
            ele.fieldName = ele.fieldName + '_' + index;
          }
        })
        console.log(this.customFieldsArray)
      }
    });
  }


  // STEP 2
  // select Location Type
  selectLocationType(locationType) {
    this.selectedLocationType = locationType;

  }

  // set searched Address
  setAddress(data) {
    console.log(data)
    this.locationFormGroup.controls['city'].setValue(data.city);
    this.locationFormGroup.controls['city'].updateValueAndValidity();
  }

  //check for valid address
  onAddressValidityChanged(isValid: boolean): void {
  }


  // STEP 3
  setFieldName(index: number) {
    const deliverables = this.trackingForm.get('deliverables') as FormArray;
    const deliverable = deliverables.at(index) as FormGroup;
    console.log("deliverable=======", deliverable, deliverables)
    if (deliverable) {
      const fieldName = deliverable.get('fieldLabel').value;
      if (fieldName) {
        const lowerCaseName = fieldName.replaceAll(' ', '_').toLowerCase();
        if (deliverable.get('fieldType').value.includes('file')) {
          deliverable.get('fieldName').setValue(lowerCaseName + '_image_' + index);
        } else {
          deliverable.get('fieldName').setValue(lowerCaseName + '_' + index);
        }
      }
    }
  }

  setFieldLabel(field: any, index: number) {
    console.log(field)
    const deliverables = this.trackingForm.get('deliverables') as FormArray;
    const deliverable = deliverables.at(index) as FormGroup;
    console.log("deliverable=======", deliverable)
    if (deliverable) {
      deliverable.get('fieldType').setValue(field.type);
      deliverable.get('displayFieldType').setValue(field.displyType);
    }
    if (field && field.name != 'order_id' && field.name != 'order_image' && field.name != 'phone_number_with_otp') {
      if (deliverable) {
        const fieldName = deliverable.get('fieldLabel').value;
        if (fieldName) {
          const lowerCaseName = fieldName.replaceAll(' ', '_').toLowerCase();
          if (deliverable.get('fieldType').value.includes('file')) {
            deliverable.get('fieldName').setValue(lowerCaseName + '_image_' + index);
          } else {
            deliverable.get('fieldName').setValue(lowerCaseName + '_' + index);
          }
        }
      }
    } else {
      if (field.name == 'order_id' || field.name == 'phone_number_with_otp' || field.name == 'order_image') {
        const fieldNameToCheck = field.name;
        if (this.trackingForm.get('deliverables').value && this.trackingForm.get('deliverables').value.length) {
          const isFieldNameAvailable = this.trackingForm.get('deliverables').value.some(item => item.fieldName === fieldNameToCheck);
          if (isFieldNameAvailable) {
            // deliverable.get('fieldType').setValue("");
            deliverable.get('displayFieldType').setValue("");
            deliverable.get('fieldName').setValue("");
            this.notify.showMessage(`Field with "${fieldNameToCheck}" is available in the deliverales.`, 2000);
          } else {
            deliverable.get('fieldName').setValue(field.name);
            deliverable.get('fieldLabel').setValue(field.label);
            deliverable.get('displayFieldType').setValue(field.displyType);
            deliverable.get('fieldType').setValue(field.type);
          }
        } else {
          deliverable.get('fieldName').setValue(field.name);
        }
      }

    }
  }

  // delete Deliverable
  deleteDeliverable(index: number) {
    const deliverables = this.trackingForm.get('deliverables') as FormArray;
    deliverables.removeAt(index);
  }

  // add More Deliverables
  addMoreDeliverables() {
    const deliverables = this.trackingForm.get('deliverables') as FormArray;
    const newDeliverable = this.deliverablesForm();
    newDeliverable.get('mandatory').setValue(true); // Set 'mandatory' to true for the new row
    deliverables.push(newDeliverable);
  }

  // STEP 4
  // Method to add more 'rateCards'
  addMoreRateCards() {
    const rateCardsArray = this.billingFormGroup.get('rateCards') as FormArray;
    rateCardsArray.push(this.createFixRateCard());
  }

  addMoreVariableRateCards() {
    const variableRateCardsArray = this.billingFormGroup.get('variableJobRateCards') as FormArray;
    variableRateCardsArray.push(this.createVariableRateCard());
  }

  // Method to delete a specific 'rateCard' by index
  deleteRateCard(index: number) {
    const rateCardsArray = this.billingFormGroup.get('rateCards') as FormArray;
    rateCardsArray.removeAt(index);
  }

  // Method to delete a specific 'rateCard' by index
  deleteVariableRateCard(index: number) {
    const variableRateCardsArray = this.billingFormGroup.get('variableJobRateCards') as FormArray;
    variableRateCardsArray.removeAt(index);
  }

  changeLocationTracking(event: any) {
    if (event.checked) {
      this.trackingForm.controls['geoFencingRadiusRequired'].setValue(true);
      this.trackingForm.controls['locationTrackingFrequency'].setValidators(Validators.required);
      this.trackingForm.controls['geoFencingRadius'].setValidators(Validators.required);
    } else {
      this.trackingForm.controls['geoFencingRadiusRequired'].setValue(false);
      this.trackingForm.controls['locationTrackingFrequency'].setValidators([])
      this.trackingForm.controls['geoFencingRadius'].setValidators([])
    }
    this.trackingForm.controls['locationTrackingFrequency'].updateValueAndValidity();
    this.trackingForm.controls['geoFencingRadius'].updateValueAndValidity();
    this.trackingForm.controls['geoFencingRadiusRequired'].updateValueAndValidity();
  }

  // select Billing Type
  selectBillingType(type) {
    this.selectedBillingType = type;
    this.billingFormGroup.controls['billingType'].setValue(type);
    this.billingFormGroup.controls['billingType'].updateValueAndValidity();

    const rateCardsArray = this.billingFormGroup.get('rateCards') as FormArray;
    const variableRateCardsArray = this.billingFormGroup.get('variableJobRateCards') as FormArray;

    if (this.billingFormGroup.controls['billingType'].value == 'FIXED') {
      rateCardsArray.clear();
      rateCardsArray.push(this.createFixRateCard());
      variableRateCardsArray.clear();
      variableRateCardsArray.clearValidators();

    }

    if (this.billingFormGroup.controls['billingType'].value == 'VARIABLE') {
      variableRateCardsArray.clear();
      variableRateCardsArray.push(this.createVariableRateCard());
      rateCardsArray.clear();
      rateCardsArray.clearValidators();

    }

    if (this.billingFormGroup.controls['billingType'].value == 'FIXED_AND_VARIABLE') {
      rateCardsArray.clear();
      rateCardsArray.push(this.createFixRateCard());
      variableRateCardsArray.clear();
      variableRateCardsArray.push(this.createVariableRateCard());

    }
  }

  // add more Section Card
  addMoreSectionCard() {
    const fixRateSections = this.billingFormGroup.get('fixRateSections') as FormArray;
    fixRateSections.push(this.createFixRateCardSectionArray('FIXED'));
  }

  // add More Variable Section Card
  addMoreVariableSectionCard() {
    const variableRateSections = this.billingFormGroup.get('variableRateSections') as FormArray;
    variableRateSections.push(this.createFixRateCardSectionArray('VARIABLE'));
  }

  // edit fixed rate Section Title 
  editSectionTitle(i) {
    const fixRateSections = this.billingFormGroup.get('fixRateSections') as FormArray;
    const sectionGroup = fixRateSections.controls[i] as FormGroup;
    sectionGroup.get('isEditSectionTitle').setValue(!sectionGroup.get('isEditSectionTitle').value);
  }

  // edit fixed rate Section Title 
  editVariableSectionTitle(i) {
    const variableRateSections = this.billingFormGroup.get('variableRateSections') as FormArray;
    const sectionGroup = variableRateSections.controls[i] as FormGroup;
    sectionGroup.get('isEditSectionTitle').setValue(!sectionGroup.get('isEditSectionTitle').value);
  }

  // add more fixed  Section Rate Card
  addMoreSectionRateCard(i) {
    const fixRateSections = this.billingFormGroup.get('fixRateSections') as FormArray;
    const sectionGroup = fixRateSections.controls[i] as FormGroup;
    const rateCardsArray = sectionGroup.get('rateCards') as FormArray;
    rateCardsArray.push(this.createFixRateCard());
  }

  // add more variable Section Rate Card
  addMoreVariableSectionRateCard(i) {
    const variableRateSections = this.billingFormGroup.get('variableRateSections') as FormArray;
    const sectionGroup = variableRateSections.controls[i] as FormGroup;
    const variableJobRateCardsArray = sectionGroup.get('variableJobRateCards') as FormArray;
    variableJobRateCardsArray.push(this.createVariableRateCard());
  }

  // toggle Expand
  toggleExpand(index: number, forWhat: string) {
    if (forWhat == 'FIXED') {
      const rateCards = this.billingFormGroup.get('rateCards') as FormArray;
      rateCards.controls.forEach((rateCard: FormGroup, idx) => {
        if (index == idx) {
          rateCard.controls['expanded'].setValue(!rateCard.controls['expanded'].value);
        }
      });
    }

    if (forWhat == 'VARIABLE') {
      const variableJobRateCards = this.billingFormGroup.get('variableJobRateCards') as FormArray;
      variableJobRateCards.controls.forEach((rateCard: FormGroup, idx) => {
        if (index == idx) {
          rateCard.controls['expanded'].setValue(!rateCard.controls['expanded'].value);
        }
      });
    }
  }

  // review page toggle expand
  toggleExpandValue(index: number, forWhat?: string) {
    if (forWhat == 'FIXED') {
      this.filledProjectDetails.rateCards.forEach((rateCard: any, idx) => {
        if (index == idx) {
          rateCard.expanded = !rateCard.expanded;
        }
      });
    }

    if (forWhat == 'VARIABLE') {
      this.filledProjectDetails.variableJobRateCards.forEach((rateCard: any, idx) => {
        if (index == idx) {
          rateCard.expanded = !rateCard.expanded;
        }
      });
    }
  }


  // delete Section Card
  deleteSectionCard(i) {
    const fixRateSections = this.billingFormGroup.get('fixRateSections') as FormArray;
    fixRateSections.removeAt(i);
  }

  // delete Section Rate Card
  deleteSectionRateCard(i, j) {
    const fixRateSections = this.billingFormGroup.get('fixRateSections') as FormArray;
    const sectionGroup = fixRateSections.controls[i] as FormGroup;
    const rateCardsArray = sectionGroup.get('rateCards') as FormArray;
    rateCardsArray.removeAt(j);
  }

  // get Total Billing
  getTotalBilling() {
    let totalBilling = 0;
    if (this.billingFormGroup.controls['billingType'].value.includes('FIXED')) {
      const rateCards = this.billingFormGroup.get('rateCards') as FormArray;
      rateCards.controls.forEach((rateCard: FormGroup) => {
        const quantity = rateCard.get('quantity').value;
        const rate = rateCard.get('rate').value;
        const days = rateCard.get('days').value;
        totalBilling = totalBilling + (quantity * rate * days);
      });
    }

    if (this.billingFormGroup.controls['billingType'].value.includes('VARIABLE')) {
      const variableJobRateCards = this.billingFormGroup.get('variableJobRateCards') as FormArray;
      variableJobRateCards.controls.forEach((rateCard: FormGroup) => {
        const quantity = rateCard.get('quantity').value;
        const rate = rateCard.get('rate').value;
        totalBilling = totalBilling + (quantity * rate);
      });
    }

    return totalBilling;
  }

  // get Total Billing's GST
  getTotalBillingGST() {
    let totalBillingGST = 0;
    if (this.billingFormGroup.controls['billingType'].value.includes('FIXED')) {
      const rateCards = this.billingFormGroup.get('rateCards') as FormArray;
      rateCards.controls.forEach((rateCard: FormGroup) => {
        const quantity = rateCard.get('quantity').value;
        const rate = rateCard.get('rate').value;
        const days = rateCard.get('days').value;
        totalBillingGST = totalBillingGST + (quantity * rate * days);
      });
    }

    if (this.billingFormGroup.controls['billingType'].value.includes('VARIABLE')) {
      const variableJobRateCards = this.billingFormGroup.get('variableJobRateCards') as FormArray;
      variableJobRateCards.controls.forEach((rateCard: FormGroup) => {
        const quantity = rateCard.get('quantity').value;
        const rate = rateCard.get('rate').value;
        totalBillingGST = totalBillingGST + (quantity * rate);
      });
    }
    return totalBillingGST * 0.18;
  }

  // get Total Billing With GST
  getTotalBillingWithGST() {
    let totalBillingWithGST = 0;

    if (this.billingFormGroup.controls['billingType'].value.includes('FIXED')) {
      const rateCards = this.billingFormGroup.get('rateCards') as FormArray;
      rateCards.controls.forEach((rateCard: FormGroup) => {
        const quantity = rateCard.get('quantity').value;
        const rate = rateCard.get('rate').value;
        const days = rateCard.get('days').value;
        totalBillingWithGST = totalBillingWithGST + (quantity * rate * days);
      });
    }

    if (this.billingFormGroup.controls['billingType'].value.includes('VARIABLE')) {
      const variableJobRateCards = this.billingFormGroup.get('variableJobRateCards') as FormArray;
      variableJobRateCards.controls.forEach((rateCard: FormGroup) => {
        const quantity = rateCard.get('quantity').value;
        const rate = rateCard.get('rate').value;
        totalBillingWithGST = totalBillingWithGST + (quantity * rate);
      });
    }

    return totalBillingWithGST * 1.18;
  }


  // STEP 5
  // job Expiry Date Change
  jobExpiryDateChange(event) {

  }

  // STEP 6
  editDisplySection(event, index) {
    event.stopPropagation();
    console.log(index)
    this.formDisplayPage = true;
    if (this.hideUneditableFields) {
      this.stepper.selectedIndex = 0;
    } else {
      this.stepper.selectedIndex = index;
    }
  }

  goToReviewStep() {
    this.setupFormDetails();
    this.stepper.selectedIndex = this.stepper.steps.length - 1;
  }

  getTotalQuantity() {
    let quantity = 0;
    if (this.filledProjectDetails && this.filledProjectDetails.billingType.includes('FIXED')) {
      if (this.filledProjectDetails.rateCards && this.filledProjectDetails.rateCards.length) {
        this.filledProjectDetails.rateCards.forEach(element => {
          quantity = quantity + element.quantity;
        });
      }
    }
    if (this.filledProjectDetails && this.filledProjectDetails.billingType.includes('VARIABLE')) {
      if (this.filledProjectDetails.variableJobRateCards && this.filledProjectDetails.variableJobRateCards.length) {
        this.filledProjectDetails.variableJobRateCards.forEach(element => {
          quantity = quantity + element.quantity;
        });
      }
    }
    return quantity;
  }

  preventToggle(event: Event) {
    event.stopPropagation();
  }

  // This method fetches job types and populates the dropdown
  loadJobTypes() {
    let params = new HttpParams()
      .set('page', this.pageIndex.toString())
      .set('size', this.pageSize.toString())
      .set('sort', 'createdOn,desc');

    this.projectTypeService.getProjectTypes(params).subscribe(data => {
      console.log('Data received:', data);
      if (data.content && data.content.length) {
        this.jobTypes = data.content;
        console.log('Filtered Job Types:', this.jobTypes);
      }
    });
  }

  // This method is triggered when the user selects a job type from the dropdown
  onJobTypeSelectionChange(event: any) {
    const selectedJobTypeId = event.value;
    console.log('Selected Job Type ID:', selectedJobTypeId);

    // Set the selected jobTypeId in the form
    this.projectFormGroup.controls['jobTypeId'].setValue(selectedJobTypeId);
    this.projectFormGroup.controls['jobTypeId'].updateValueAndValidity();
  }

  // Get Initial letter from JobSeeker name
  getUserNameInitial(full_name) {
    let initialOfName = null;
    if (full_name) {
      if (full_name.split(' ').length == 1) {
        initialOfName = full_name.split(' ')[0].split('')[0];
      }
      if (full_name.split(' ').length > 1) {
        initialOfName = full_name.split(' ')[0].split('')[0] + (full_name.split(' ')[1].split('')[0] ? full_name.split(' ')[1].split('')[0] : '')
      }
      return initialOfName ? initialOfName : full_name.split('')[0];
    }
  }

  // common search filter
  search() {
    clearTimeout(this.timeoutRef);
    this.timeoutRef = setTimeout(() => {
      this.fetchTeamMembers();
    }, 700);
  }

  toggle(item, event: MatCheckboxChange) {
    // this.selection = [];
    console.log(this.selectedTeamMembers)
    if (event.checked) {
      this.selectedTeamMembers.push(item);
    } else {
      const index = this.selectedTeamMembers.findIndex(x => x.id === item.id);
      if (index >= 0) {
        this.selectedTeamMembers.splice(index, 1);
      }
    }
  }

  exists(item) {
    if (this.selectedTeamMembers && this.selectedTeamMembers.length)
      return this.selectedTeamMembers.indexOf(item) > -1;
  };

  isIndeterminate() {
    if (this.selectedTeamMembers && this.selectedTeamMembers.length)
      return (this.selectedTeamMembers.length > 0 && !this.isChecked());
  };

  isChecked() {
    if (this.selectedTeamMembers && this.selectedTeamMembers.length)
      return this.selectedTeamMembers.length === this.teamMembers.length;
  };

  toggleAll(event: MatCheckboxChange) {
    this.selectedAll = event.checked;
    this.selectedTeamMembers = [];
    if (!this.selectedAll) {
      this.teamMembers.forEach(el => {
        el.checked = false;
      })
    }
    if (event.checked) {
      this.teamMembers.forEach(row => {
        if (!row.assigned)
          this.selectedTeamMembers.push(row)
      });
    } else {
      this.selectedTeamMembers.length = 0;
    }
  }

  selectFieldType(type: any) {
    const deliverables = this.trackingForm.get('deliverables') as FormArray;

    // Create a new field card and set values based on selected type
    const newFieldCard = this.deliverablesForm();


    // Set the fieldType, displayFieldType, and fieldLabel based on the selected type
    newFieldCard.patchValue({
      fieldType: type.type, // Set fieldType
      displayFieldType: type.displyType, // Set displayFieldType
      fieldLabel: type.label, // Set fieldLabel to the same value as fieldType
    });

    // Add the new field card to the FormArray
    deliverables.push(newFieldCard);


    // Get the index of the newly added field card
    const index = deliverables.length - 1;

    // Generate the unique fieldName
    const fieldLabel = type.label;
    const lowerCaseName = fieldLabel.replace(/\s+/g, '_').toLowerCase();
    const fieldName = lowerCaseName + (type.type.includes('file') ? '_image_' : '_') + index;

    // Set the generated fieldName
    newFieldCard.get('fieldName').setValue(fieldName);
  }

  updateDisplayType(selectedType: any, index: number) {
    console.log('Selected Display Type:', selectedType);

    // Get the FormArray from the form
    const deliverables = this.trackingForm.get('deliverables') as FormArray;

    // Get the specific FormGroup for the current index
    const currentFieldCard = deliverables.at(index) as FormGroup;

    // Find the fieldType object matching the selected display type
    const fieldType = this.fieldsType.find((field) => field.displyType === selectedType);

    if (fieldType) {
      currentFieldCard.patchValue({
        displayFieldType: fieldType.displyType,
        fieldType: fieldType.type,
      });

      // update the fieldLabel
      currentFieldCard.get('fieldLabel').setValue(fieldType.label);

      // Generate and update the fieldName based on the new selection
      const fieldLabel = fieldType.label;
      const lowerCaseName = fieldLabel.replace(/\s+/g, '_').toLowerCase();
      const fieldName = lowerCaseName + (fieldType.type.includes('file') ? '_image_' : '_') + index;
      currentFieldCard.get('fieldName').setValue(fieldName);
    }
  }
}
